module.exports = __webpack_public_path__ + "img/6f970c9.png";